
import { Component, Vue } from 'vue-property-decorator';
import { getQuestionnaire, returnVisit } from '@/api/orderService';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'orderServicerCompleted',
  components: {

  }
})
export default class extends Vue {
  private list: any = []
  private questionList: any = []
  private labelPosition = 'top'
  private radioQuest:any = ''
  private formQuest: any = {

  }
  private detailOrder:any={}
  created() {
    this.detailOrder = JSON.parse(this.$route.query.orderDetail as string);
    this.getQuestionnaire();
  }
  private getQuestionnaire() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    getQuestionnaire(pamars).then(res => {
      if (res.data) {
        this.list = res.data.list;
        if (this.list && this.list.length > 0) {
          this.radioQuest = this.list[0];
          this.questionList = this.list[0].question_list;
          this.getQuestionArr(this.questionList);
        }
      } else {
        this.list = [];
      }
    });
  }
  private questionnaireSelect(val: any) {
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].id === this.radioQuest.id) {
        this.questionList = this.list[i].question_list;
        this.getQuestionArr(this.questionList);
      }
    }
  }
  private getQuestionArr(val: any) {
    var objt: any = {};
    for (var i = 0; i < val.length; i++) {
      if (val[i].question_type === '2') {
        objt[val[i].id] = [];
      }
      if (val[i].question_type === '3') {
        objt[val[i].id] = '';
      }
    }
    this.formQuest = objt;
  }
  private onSubmit(val: any) {
    let question:any = [];
    for (const key in this.formQuest) {
      let elementAnswer = this.formQuest[key];
      this.questionList.forEach((element:any) => {
        if (element.id === key) {
          switch (parseInt(element.question_type)) {
            case 1: {
              let ob:any = {};
              ob.question_title = element.question_title;
              ob.question_type = element.question_type;
              ob.question_answer = element.question_answer;
              ob.question_answer[elementAnswer].select = 1;
              question.push(ob);
              break;
            }
            case 2: {
              if (elementAnswer && elementAnswer.length > 0) {
                let ob:any = {};
                ob.question_title = element.question_title;
                ob.question_type = element.question_type;
                ob.question_answer = element.question_answer;
                for (let index = 0; index < elementAnswer.length; index++) {
                  const elementa = elementAnswer[index];
                  ob.question_answer[elementa].select = 1;
                }
                question.push(ob);
              }
              break;
            }
            case 3: {
              if (elementAnswer) {
                let ob:any = {};
                ob.question_title = element.question_title;
                ob.question_type = element.question_type;
                ob.question_answer = elementAnswer;
                question.push(ob);
              }
              break;
            }
          }
        }
      });
    }
    if (!(question && question.length > 0)) {
      this.showErrorMsg('请填写回访问题');
      return;
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.id = this.detailOrder.order_service.id;
    pamars.question = JSON.stringify(question);
    returnVisit(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.$router.go(-1);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
